var map = {
	"./AD.png": 1374,
	"./AE.png": 1375,
	"./AF.png": 1376,
	"./AG.png": 1377,
	"./AI.png": 1378,
	"./AL.png": 1379,
	"./AM.png": 1380,
	"./AN.png": 1381,
	"./AO.png": 1382,
	"./AQ.png": 1383,
	"./AR.png": 1384,
	"./AS.png": 1385,
	"./AT.png": 1386,
	"./AU.png": 1387,
	"./AW.png": 1388,
	"./AX.png": 1389,
	"./AZ.png": 1390,
	"./BA.png": 1391,
	"./BB.png": 1392,
	"./BD.png": 1393,
	"./BE.png": 1394,
	"./BF.png": 1395,
	"./BG.png": 1396,
	"./BH.png": 1397,
	"./BI.png": 1398,
	"./BJ.png": 1399,
	"./BL.png": 1400,
	"./BM.png": 1401,
	"./BN.png": 1402,
	"./BO.png": 1403,
	"./BR.png": 1404,
	"./BS.png": 1405,
	"./BT.png": 1406,
	"./BW.png": 1407,
	"./BY.png": 1408,
	"./BZ.png": 1409,
	"./CA.png": 1410,
	"./CC.png": 1411,
	"./CD.png": 1412,
	"./CF.png": 1413,
	"./CG.png": 1414,
	"./CH.png": 1415,
	"./CI.png": 1416,
	"./CK.png": 1417,
	"./CL.png": 1418,
	"./CM.png": 1419,
	"./CN.png": 1420,
	"./CO.png": 1421,
	"./CR.png": 1422,
	"./CU.png": 1423,
	"./CV.png": 1424,
	"./CW.png": 1425,
	"./CX.png": 1426,
	"./CY.png": 1427,
	"./CZ.png": 1428,
	"./DE.png": 1429,
	"./DJ.png": 1430,
	"./DK.png": 1431,
	"./DM.png": 1432,
	"./DO.png": 1433,
	"./DZ.png": 1434,
	"./EC.png": 1435,
	"./EE.png": 1436,
	"./EG.png": 1437,
	"./EH.png": 1438,
	"./ER.png": 1439,
	"./ES.png": 1440,
	"./ET.png": 1441,
	"./EU.png": 1442,
	"./FI.png": 1443,
	"./FJ.png": 1444,
	"./FK.png": 1445,
	"./FM.png": 1446,
	"./FO.png": 1447,
	"./FR.png": 1448,
	"./GA.png": 1449,
	"./GB.png": 1450,
	"./GD.png": 1451,
	"./GE.png": 1452,
	"./GG.png": 1453,
	"./GH.png": 1454,
	"./GI.png": 1455,
	"./GL.png": 1456,
	"./GM.png": 1457,
	"./GN.png": 1458,
	"./GQ.png": 1459,
	"./GR.png": 1460,
	"./GS.png": 1461,
	"./GT.png": 1462,
	"./GU.png": 1463,
	"./GW.png": 1464,
	"./GY.png": 1465,
	"./HK.png": 1466,
	"./HN.png": 1467,
	"./HR.png": 1468,
	"./HT.png": 1469,
	"./HU.png": 1470,
	"./IC.png": 1471,
	"./ID.png": 1472,
	"./IE.png": 1473,
	"./IL.png": 1474,
	"./IM.png": 1475,
	"./IN.png": 1476,
	"./IQ.png": 1477,
	"./IR.png": 1478,
	"./IS.png": 1479,
	"./IT.png": 1480,
	"./JE.png": 1481,
	"./JM.png": 1482,
	"./JO.png": 1483,
	"./JP.png": 1484,
	"./KE.png": 1485,
	"./KG.png": 1486,
	"./KH.png": 1487,
	"./KI.png": 1488,
	"./KM.png": 1489,
	"./KN.png": 1490,
	"./KP.png": 1491,
	"./KR.png": 1492,
	"./KW.png": 1493,
	"./KY.png": 1494,
	"./KZ.png": 1495,
	"./LA.png": 1496,
	"./LB.png": 1497,
	"./LC.png": 1498,
	"./LI.png": 1499,
	"./LK.png": 1500,
	"./LR.png": 1501,
	"./LS.png": 1502,
	"./LT.png": 1503,
	"./LU.png": 1504,
	"./LV.png": 1505,
	"./LY.png": 1506,
	"./MA.png": 1507,
	"./MC.png": 1508,
	"./MD.png": 1509,
	"./ME.png": 1510,
	"./MF.png": 1511,
	"./MG.png": 1512,
	"./MH.png": 1513,
	"./MK.png": 1514,
	"./ML.png": 1515,
	"./MM.png": 1516,
	"./MN.png": 1517,
	"./MO.png": 1518,
	"./MP.png": 1519,
	"./MQ.png": 1520,
	"./MR.png": 1521,
	"./MS.png": 1522,
	"./MT.png": 1523,
	"./MU.png": 1524,
	"./MV.png": 1525,
	"./MW.png": 1526,
	"./MX.png": 1527,
	"./MY.png": 1528,
	"./MZ.png": 1529,
	"./NA.png": 1530,
	"./NC.png": 1531,
	"./NE.png": 1532,
	"./NF.png": 1533,
	"./NG.png": 1534,
	"./NI.png": 1535,
	"./NL.png": 1536,
	"./NO.png": 1537,
	"./NP.png": 1538,
	"./NR.png": 1539,
	"./NU.png": 1540,
	"./NZ.png": 1541,
	"./OM.png": 1542,
	"./PA.png": 1543,
	"./PE.png": 1544,
	"./PF.png": 1545,
	"./PG.png": 1546,
	"./PH.png": 1547,
	"./PK.png": 1548,
	"./PL.png": 1549,
	"./PN.png": 1550,
	"./PR.png": 1551,
	"./PS.png": 1552,
	"./PT.png": 1553,
	"./PW.png": 1554,
	"./PY.png": 1555,
	"./QA.png": 1556,
	"./RO.png": 1557,
	"./RS.png": 1558,
	"./RU.png": 1559,
	"./RW.png": 1560,
	"./SA.png": 1561,
	"./SB.png": 1562,
	"./SC.png": 1563,
	"./SD.png": 1564,
	"./SE.png": 1565,
	"./SG.png": 1566,
	"./SH.png": 1567,
	"./SI.png": 1568,
	"./SK.png": 1569,
	"./SL.png": 1570,
	"./SM.png": 1571,
	"./SN.png": 1572,
	"./SO.png": 1573,
	"./SR.png": 1574,
	"./SS.png": 1575,
	"./ST.png": 1576,
	"./SV.png": 1577,
	"./SY.png": 1578,
	"./SZ.png": 1579,
	"./TC.png": 1580,
	"./TD.png": 1581,
	"./TF.png": 1582,
	"./TG.png": 1583,
	"./TH.png": 1584,
	"./TJ.png": 1585,
	"./TK.png": 1586,
	"./TL.png": 1587,
	"./TM.png": 1588,
	"./TN.png": 1589,
	"./TO.png": 1590,
	"./TR.png": 1591,
	"./TT.png": 1592,
	"./TV.png": 1593,
	"./TW.png": 1594,
	"./TZ.png": 1595,
	"./UA.png": 1596,
	"./UG.png": 1597,
	"./US.png": 1598,
	"./UY.png": 1599,
	"./UZ.png": 1600,
	"./VA.png": 1601,
	"./VC.png": 1602,
	"./VE.png": 1603,
	"./VG.png": 1604,
	"./VI.png": 1605,
	"./VN.png": 1606,
	"./VU.png": 1607,
	"./WF.png": 1608,
	"./WS.png": 1609,
	"./YE.png": 1610,
	"./YT.png": 1611,
	"./ZA.png": 1612,
	"./ZM.png": 1613,
	"./ZW.png": 1614,
	"./КЗ.png": 1615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1373;